export const PLAN_TYPES = {
    MONTH: "month",
    YEAR: "year",
};

export const PRICE_PERCENTAGE = 0.90;
